import { createAsyncThunk } from '@reduxjs/toolkit';
import TemplateResource from 'api/service/TemplateResource';

export const loadTemplate = createAsyncThunk('artworks/loadTemplate', async (initialData, { rejectWithValue }) => {
  const templatesResource = new TemplateResource();
  const { templateId, propertyId } = initialData;
  const { status, data } = await templatesResource.load(templateId, propertyId);
  if (status === 200) {
    return data;
  }
  return rejectWithValue('Error loading template');
});

export const listTemplates = createAsyncThunk('artworks/listTemplates', async () => {
  const templatesResource = new TemplateResource();
  const { status, data } = await templatesResource.list({ s: 10 });
  if (status === 200) {
    return data;
  }
  return [];
});
